import React from "react";
import { useTranslation } from "react-i18next";

// Browser not supported instructions component
const BrowserNotSupportedInstructions: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div>
      <p className="mb-2 font-semibold text-foreground">
        {t("browserNotSupported")}
      </p>
      <p className="text-sm text-foreground">
        {t("browserNotSupportedDescription")}
      </p>
    </div>
  );
};

export default BrowserNotSupportedInstructions;
